import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import './scss/index.scss';
import './i18n';
import './utils/api/axiosInterceptor';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>,
);

reportWebVitals();
